import { API, graphqlOperation } from 'aws-amplify';
import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import { toast } from 'react-toastify';
import * as queries from '../../graphql/queries'; // Import your GraphQL queries
import * as mutations from '../../graphql/mutations'; // Import your GraphQL queries
import {
  CREATE_HOME_ACTIVITIES_REQUEST,
  CREATE_HOME_ACTIVITIES_SUCCESS,
  CREATE_HOME_ACTIVITIES_FAIL,
  UPDATE_HOME_ACTIVITIES_REQUEST,
  UPDATE_HOME_ACTIVITIES_SUCCESS,
  UPDATE_HOME_ACTIVITIES_FAIL,
  GET_HOME_ACTIVITIES_REQUEST,
  GET_HOME_ACTIVITIES_SUCCESS,
  GET_HOME_ACTIVITIES_FAIL,
  LOAD_HOME_ACTIVITIESS_REQUEST,
  LOAD_HOME_ACTIVITIESS_SUCCESS,
  LOAD_HOME_ACTIVITIESS_FAIL,
  LIST_HOME_ACTIVITIESS_REQUEST,
  LIST_HOME_ACTIVITIESS_SUCCESS,
  LIST_HOME_ACTIVITIESS_FAIL,
  DELETE_HOME_ACTIVITIES_REQUEST,
  DELETE_HOME_ACTIVITIES_SUCCESS,
  DELETE_HOME_ACTIVITIES_FAIL,
  DELETE_HOME_ACTIVITIES_RESET,
  CLEAR_HOME_ACTIVITIES_ERRORS,
} from '../constants/HomeActivitiesConstants';
import getLinks from '../../utils/getLinks';
import uploadFile from '../../utils/uploadFile';
import deleteFile from '../../utils/deleteFile';


export const getAllHomeActivities = () => async (dispatch) => {
  try {
    dispatch({ type: LIST_HOME_ACTIVITIESS_REQUEST });
    const response = await API.graphql(graphqlOperation(queries.listHomeActivities));

    const data = response.data.listHomeActivities.items || [];
    const updatedHomeActivities = await Promise.all(
      data?.map(async (product) => {
        try {
          const signedUrl = await getLinks(product?.imageURL);
          return { ...product, img_url: signedUrl };
        } catch (error) {
          toast.error('Something Went Wrong!');
          console.error('Error fetching Activity image URL', error);
          return product;
        }
      })
    );
    updatedHomeActivities.sort((a, b) => {
      if (a.createdAt > b.createdAt) {
        return -1;
      } else if (a.createdAt < b.createdAt) {
        return 1;
      } else {
        return 0;
      }
    });

    const updatedData = {
      homeActivities: updatedHomeActivities,
      activitiesCount: updatedHomeActivities?.length,
      resultPerPage: 10,
      filteredActivitiesCount: null,
    };

    dispatch({
      type: LIST_HOME_ACTIVITIESS_SUCCESS,
      payload: updatedData,
    });
  } catch (error) {
    dispatch({
      type: LIST_HOME_ACTIVITIESS_FAIL,
      payload: error,
    });
  }
};

export const createHomeActivity = (formData) => async (dispatch) => {
  // console.log('activities data',data);
  try {
    dispatch({ type: CREATE_HOME_ACTIVITIES_REQUEST });
    const imageUrl = await uploadFile(formData.imageURL);
   
    const response = await API.graphql({
      query: mutations.createHomeActivities,
      variables: {
        input: {
          title: formData.title,
          imageURL: imageUrl,
          link: formData.link,
       
        },
      },

      authMode: GRAPHQL_AUTH_MODE.API_KEY,
    });
    const data = response.data.createHomeActivities;

    toast.success('Activity Added Successfully!');

    dispatch({
      type: CREATE_HOME_ACTIVITIES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log('activities error', error);
    toast.error('Something Went Wrong!');

    dispatch({
      type: CREATE_HOME_ACTIVITIES_FAIL,
      payload: error,
    });
  }
};
export const deleteHomeActivities = (id) => async (dispatch) => {
  console.log('ID', id);
  try {
    dispatch({ type: DELETE_HOME_ACTIVITIES_REQUEST });
  
    const res = await API.graphql(graphqlOperation(queries.getHomeActivities, { id }), {
      authMode: GRAPHQL_AUTH_MODE.API_KEY,
    });

    const isDeleted = await deleteFile(res?.data?.getHomeActivities?.imageURL);

    if (isDeleted) {
      API.graphql({
        query: mutations.deleteHomeActivities,
        variables: { input: { id } },
        authMode: GRAPHQL_AUTH_MODE.API_KEY,
      }).then(async (response) => {
        console.log(response);
        toast.success('Activity Deleted Successfully!');

        dispatch({
          type: DELETE_HOME_ACTIVITIES_SUCCESS,
          payload: true,
        });
      });
    }
  } catch (error) {
    toast.error('Something Went Wrong!');

    console.log('Error', error);
    dispatch({
      type: DELETE_HOME_ACTIVITIES_FAIL,
      payload: error || 'Failed to fetch cart data',
    });
  }
};

export const deleteMultipleHomeActivities = (ids) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_HOME_ACTIVITIES_REQUEST });

    // Step 1: Fetch all tournament team details in parallel
    const fetchPromises = ids.map((id) =>
      API.graphql(graphqlOperation(queries.getHomeActivities, { id }), {
        authMode: GRAPHQL_AUTH_MODE.API_KEY,
      }).then((res) => ({
        id,
        imageURL: res?.data?.getHomeActivities?.imageURL,
      }))
    );

    const activities = await Promise.all(fetchPromises);

    // Step 2: Delete all images in parallel
    await Promise.all(activities.map((team) => deleteFile(team.imageURL)));

    // Step 3: Delete all activities in parallel
    const deletePromises = activities.map((team) =>
      API.graphql({
        query: mutations.deleteHomeActivities,
        variables: { input: { id: team.id } },
        authMode: GRAPHQL_AUTH_MODE.API_KEY,
      })
    );

    await Promise.all(deletePromises);

    toast.success('Selected Activities deleted successfully!');
    dispatch({ type: DELETE_HOME_ACTIVITIES_SUCCESS, payload: true });
  } catch (error) {
    toast.error('Bulk delete failed!');
    console.error('Bulk delete error:', error);
    dispatch({
      type: DELETE_HOME_ACTIVITIES_FAIL,
      payload: error || 'Failed to delete selected tournament activities',
    });
  }
};

export const getActivityDetails = (activitiesId) => async (dispatch) => {
  try {
    dispatch({ type: GET_HOME_ACTIVITIES_REQUEST });

    const response = await API.graphql(graphqlOperation(queries.getHomeActivities, { id: activitiesId }));

    const data = response?.data.getItem;
    dispatch({
      type: GET_HOME_ACTIVITIES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error('Something Went Wrong!');

    const errorMessage = error.response && error.response.data.message ? error.response.data.message : error.message;

    dispatch({
      type: GET_HOME_ACTIVITIES_FAIL,
      payload: errorMessage,
    });
  }
};

export const clearActivityErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_HOME_ACTIVITIES_ERRORS });
};
